import React from 'react'
import { Icon } from 'tea-component'

import * as styles from './loading.module.less'

interface Props {
  loading: boolean
  children?: any
}

const Loading = (props: Props) => {
  const {loading, children} = props
  return (
    <>
    {
      loading && (
        <div className={styles.container}>
          <span>
            <Icon type="loading" /> Loading
          </span>
        </div>
      ) || children
    }
    </>
  )
}

export default Loading